import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function signUpMembersRequest(isLoading) {
  return {
    type: actionsTypesMembers.SIGNUP_MEMBERS_REQUEST,
    isLoading,
  }
}
function signUpMembersFailure(isError) {
  return {
    type: actionsTypesMembers.SIGNUP_MEMBERS_FAILURE,
    isError,
  }
}
function signUpMembersSuccess(userData) {
  return {
    type: actionsTypesMembers.SIGNUP_MEMBERS_SUCCESS,
    userData,
  }
}
export function fetchSignUpMembersAction(userData) {
  return function(dispatch, getState) {
    //let previousState = getState()
    dispatch(signUpMembersRequest(true))

    return backendMembers.createAccount(userData)
      .then(response => {
        dispatch(signUpMembersRequest(false))
        dispatch(signUpMembersSuccess(userData))
      })
      .catch(error => {
        dispatch(signUpMembersRequest(false))
        dispatch(signUpMembersFailure(true))
      })
  }
}

function resendEmailMembersRequest(isLoading) {
  return {
    type: actionsTypesMembers.RESEND_EMAIL_MEMBERS_REQUEST,
    isLoading,
  }
}
function resendEmailMembersFailure(isError) {
  return {
    type: actionsTypesMembers.RESEND_EMAIL_MEMBERS_FAILURE,
    isError,
  }
}
function resendEmailMembersSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.RESEND_EMAIL_MEMBERS_SUCCESS,
    isSuccess,
  }
}
export function fetchResendEmailMembersAction(userEmail) {
  return function(dispatch, getState) {

    dispatch(resendEmailMembersRequest(true))

    return backendMembers.resendVerificationMail(userEmail)
      .then(response => {
        dispatch(resendEmailMembersRequest(false))
        dispatch(resendEmailMembersSuccess(true))
      })
      .catch(error => {
        dispatch(resendEmailMembersRequest(false))
        dispatch(resendEmailMembersFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Authentification/SignUpMembers.js